__turbopack_context__.v({
  "playbutton": "Vlr65a_playbutton",
  "playbuttoninner": "Vlr65a_playbuttoninner",
  "videoProgressBar": "Vlr65a_videoProgressBar",
  "videoWrapper": "Vlr65a_videoWrapper",
  "wrapper": "Vlr65a_wrapper",
});
